// removed by extract-text-webpack-plugin
module.exports = {"miniFont":"12px","miniLine":"18px","smallFont":"14px","smallLine":"20px","smallMoreFont":"16px","smallMoreLine":"24px","mediumFont":"18px","mediumLine":"26px","mediumMoreFont":"20px","mediumMoreLine":"30px","largeFont":"24px","largeLine":"32px","largeMoreFont":"28px","largeMoreLine":"36px","navHeight":"64px"};


//////////////////
// WEBPACK FOOTER
// ./styles/common.scss
// module id = K6AJ
// module chunks = 16